"use strict";

exports.__esModule = true;
exports.LocalePath = exports.LocaleLang = exports.LocaleId = void 0;
var LocaleId = exports.LocaleId = /*#__PURE__*/function (LocaleId) {
  LocaleId["au"] = "au";
  LocaleId["ca"] = "ca";
  LocaleId["global"] = "global";
  LocaleId["nz"] = "nz";
  LocaleId["uk"] = "uk";
  LocaleId["us"] = "us";
  LocaleId["eu"] = "eu";
  return LocaleId;
}({});
var LocaleLang = exports.LocaleLang = /*#__PURE__*/function (LocaleLang) {
  LocaleLang["au"] = "en-AU";
  LocaleLang["ca"] = "en-CA";
  LocaleLang["global"] = "en";
  LocaleLang["nz"] = "en-NZ";
  LocaleLang["uk"] = "en-GB";
  LocaleLang["us"] = "en-US";
  LocaleLang["eu"] = "en-EU";
  return LocaleLang;
}({});
var LocalePath = exports.LocalePath = /*#__PURE__*/function (LocalePath) {
  LocalePath["au"] = "au";
  LocalePath["ca"] = "ca";
  LocalePath["global"] = "";
  LocalePath["nz"] = "nz";
  LocalePath["uk"] = "uk";
  LocalePath["us"] = "us";
  LocalePath["eu"] = "eu";
  return LocalePath;
}({});